
















import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import PriceConfigTable from '@/components/price-configs/PriceConfigTable.vue'
import priceConfigsStore from '@/stores/PriceConfigStore'
import { Routes } from '@/router/routes'

@Component({
  components: { PriceConfigTable },
})
export default class Weights extends Vue {
  @Prop(String)
  priceConfigId: string | null

  isPending: boolean = true
  priceConfigsStore = priceConfigsStore

  get priceConfigs() {
    return this.priceConfigsStore.priceConfigs
  }

  get isFullSplitter() {
    return this.$route.name === Routes.priceConfigs
  }

  created() {
    this.loadPriceConfigs()
  }

  async loadPriceConfigs() {
    this.isPending = true
    await this.priceConfigsStore.loadPriceConfigs()
    this.isPending = false
  }

  @Watch('priceConfigId', { immediate: true })
  selectLimit(priceConfigId: string | null) {
    this.priceConfigsStore.selectPriceConfig(
      priceConfigId ? parseInt(priceConfigId) : null
    )
  }
}
